module.exports = __webpack_public_path__ + "static/media/logo_p_picktow.b03857da.svg";